import styled from 'styled-components';

import { TWrapperProps } from '@/shared/components/ui/tooltip/tooltip.types';

export const Wrapper = styled.span<TWrapperProps>`
  height: fit-content;
  width: ${({ $wrapper }) =>
    $wrapper === 'fullWidth' ? '100%' : 'fit-content'};
  display: inline-flex;
  align-items: center;
`;
